import { render, staticRenderFns } from "./communicationDashboardSignatureGenerator.vue?vue&type=template&id=e45e745c&scoped=true"
import script from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSignatureGenerator.vue?vue&type=style&index=0&id=e45e745c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45e745c",
  null
  
)

export default component.exports